import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


import { useLocalStorage } from "../../../hooks";
import { dashboardState } from "../../../redux/reducers/dashboardReducer";


import MarkAsPaidDialog from "../../../components/MarkAsPaidDialog";
import WarningDialog from "../../confirmationModals/WarningDialog";

import { EllipsisVerticalIcon } from "@heroicons/react/20/solid";
import moment from "moment";
import Alert from "../../../assets/Alert.png";
import BookingLinkModal from "../../../components/BookingLinkModal";
import { TwPopover } from "../../../components/tailwind";
import { useToast } from "../../../provider/ToastProvider";
import { loadingState, setGlobalLoading } from "../../../redux/reducers/loadingReducer";
import axiosInstance from "../../../utils/axiosInstance";
import { getUrlForBookings } from "../../../utils/confighelpers";
import { useTranslation } from "react-i18next";

export default function SessionBookingPopover({
  bookingDetails,
  handleUpdate,
}) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog } = useToast();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const [userToken] = useLocalStorage("userToken");
  const dashboardReduxState = useSelector(dashboardState);

  const {
    bookingId,
    scheduleId,
    scheduleClassId,
    studentId,
  } = bookingDetails;
  const username = bookingDetails?.consumer_detail?.username;
  const email = bookingDetails?.consumer_detail?.email;
  const userId = bookingDetails.studentId;
  const isPackage = bookingDetails.isPackage;
  const isPaid = (["paid", "refund-pendding", "refunded"].indexOf(bookingDetails?.paymentStatus?.toLowerCase()) > -1) ? true : false;
  const [popoverOptionsDisabled, setPopoverOptionsDisabled] = React.useState(false);

  const [markAsPaidDialogOpen, setMarkAsPaidDialogOpen] = React.useState(false);
  const [openPatmentProfileWarningDialog, setOpenPatmentProfileWarningDialog] = React.useState(false);
  const [openWarningDialog, setOpenWarningDialog] = React.useState(false);
  const [openCancelWarningDialog, setOpenCancelWarningDialog] = React.useState(false);
  const [warningText, setWarningText] = React.useState("");
  const [errorText, setErrorText] = React.useState(false);
  const [bookingLinkModalOpen, setBookingLinkModalOpen] = React.useState(false);
  const [shareLink, setShareLink] = React.useState("false");


  const handleOpenMarkAsPaidDialog = () => {
    setMarkAsPaidDialogOpen(true);
  };
  const handleCloseMarkAsPaidDialog = () => setMarkAsPaidDialogOpen(false);
  const handleOpenWarningDialog = () => {
    setOpenWarningDialog(true);
  };
  const handleCloseWarningDialog = () => setOpenWarningDialog(false);
  const handleOpenErrorDialog = () => {
    addNotificationDialog({
      dialogType: "error",
      dialogTitle: "Error",
      dialogMessage: errorText,
      dialogBtnTitle: t("inputFieldsTitle.ok"),
      dialogBackdropClick: async () => { },
      dialogBtnClick: async () => { }
    })
  };
  const handleBookingLinkModalOpen = () => setBookingLinkModalOpen(true);
  const handleBookingLinkModalClose = () => setBookingLinkModalOpen(false);

  const sendTikkiePromise = async (type) => {

    const body = {
      bookingId,
      forceSendLink: type,
      bookingFor: "Tikkie",
    };
    const config = {
      method: "post",
      url: `${getUrlForBookings()}payments/generateTikkiePmtLink`,
      data: body,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    return request;
  };

  const sendTikkie = async () => {
    const request = await sendTikkiePromise(false);
    if (request.status === 200) {
      if (request.data.statusCode === 417) {
        setErrorText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleOpenErrorDialog();
      } else if (request.data.statusCode === 406) {
        setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleOpenWarningDialog();
      } else if (request.data.statusCode === 403) {
        setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
        handleCloseWarningDialog();
        setOpenPatmentProfileWarningDialog(true)
      } else if (request.data.statusCode === 200) {
        /* const usernameCopy = username;
        const number = usernameCopy.replace(/[^\w\s]/gi, "").replace(/ /g, "");
        let url = `https://api.whatsapp.com/send?phone=${number}`;
        const message = `Hi! Here's the tikkie link for the payment of my session.\n${request.data.generatedUrl}`;
        url += `&text=${encodeURI(message)}&app_absent=0`;
        window.open(url); */
        setShareLink(request.data.data.generatedUrl);
        handleBookingLinkModalOpen();
      }
    }
  };

  const viewDetails = () => {
    navigate("/booking/view", {
      state: {
        bookingId: bookingId,
        from: "Home"
      },
    })
  }

  const handleMarkAsPaid = async () => {
    handleCloseMarkAsPaidDialog();

    const body = {
      bookingId,
      paymentStatus: "Paid",
      paymentMode: "Cash",
    };
    const config = {
      method: "put",
      url: `${getUrlForBookings()}payments/updatePaymentStatus`,
      data: body,
    };

    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        addSuccessToast(t("successes.success"));
        handleUpdate();
      } else {
        addErrorToast(request.data.message);
      }
    }
  };

  const handleDelete = async () => {
    setOpenCancelWarningDialog(prevState => !prevState);
  };

  const handleContactClick = () => {
    if (email) {
      window.open(`mailto:${email}`);
    } else {
      const usernameCopy = username;
      const number = usernameCopy.replace(/[^\w\s]/gi, "").replace(/ /g, "");
      window.open(`https://api.whatsapp.com/send?phone=${number}`);
    }
  };

  const popoverOptions = [
    {
      text: t("inputFieldsTitle.viewDetails"),
      onClick: viewDetails,
      disabled: false,
      icon: Alert,
    },
    {
      text: t("bookings.sendTikkie"),
      onClick: sendTikkie,
      disabled: isPaid,
      icon: Alert,
    },
    {
      text: t("bookings.markAsPaid"),
      onClick: handleOpenMarkAsPaidDialog,
      disabled: isPaid,
      icon: Alert,
    },
    {
      text: t("bookings.cancelBooking"),
      onClick: handleDelete,
      disabled: (bookingDetails.status == "Cancelled") ? true : moment(bookingDetails.event_schedule_detail.eventDate).subtract({ hours: 3 }).isBefore(),
      // disabled: (bookingDetails.status == "Cancelled") ? true : moment("2023-11-30T11:30:00.153Z").subtract({ hours: 3 }).isBefore(),
      icon: Alert,
    },
    /* {
      text: t("inputFieldsTitle.viewHistory"),
      onClick: () => undefined,
      disabled: true,
      icon: Alert,
    }, */
  ];

  return (

    <div>
      <TwPopover
        buttonClassName={""}
        buttonContent={(<EllipsisVerticalIcon aria-hidden="true" className="size-5" />)}
      >
        <div className={"flex flex-col divide-y divide-gray-200"}>
          {popoverOptions.map((opt, idx) => (
            <button
              key={idx}
              disabled={opt.disabled}
              className={`hover:bg-gray-200 p-4 text-sm text-left text-black disabled:text-lilac`}
              onClick={opt.onClick}
            >
              {opt.text}
            </button>
          ))}
        </div>
      </TwPopover>
      <MarkAsPaidDialog
        open={markAsPaidDialogOpen}
        handleClose={handleCloseMarkAsPaidDialog}
        onSubmit={handleMarkAsPaid}
      />
      <WarningDialog
        open={openWarningDialog}
        text={warningText}
        onClose={handleCloseWarningDialog}
        onSubmit={async () => {

          const request = await sendTikkiePromise(true);
          if (request.status === 200) {
            if (request.data.statusCode === 200) {
              setShareLink(request.data.data.generatedUrl);
              handleBookingLinkModalOpen();
              handleCloseWarningDialog();
            } else if (request.data.statusCode === 403) {
              setWarningText(request.data.message.errors ? t("errors.somethingIsWrong") : request.data.message);
              handleCloseWarningDialog();
              setOpenPatmentProfileWarningDialog(true)
            }
          }
        }}
      />

      <WarningDialog
        open={openCancelWarningDialog}
        text={t("bookings.cancelBookingDialogMsg")}
        onClose={() => setOpenCancelWarningDialog(false)}
        onSubmit={async () => {

          const body = {
            bookingId,
            scheduleClassId: scheduleClassId,
            // scheduleClassId: instanceId,
            type: "remove",
            isPackage,
            participantId: studentId,
            familyMemberId: "",
          };
          const config = {
            method: "post",
            url: `${getUrlForBookings()}cancelClassBooking`,
            headers: {
              "x-access-token": userToken,
            },
            data: body,
          };
          dispatch(setGlobalLoading(true));
          const request = await axiosInstance(config);
          dispatch(setGlobalLoading(false));
          if (request.status === 200) {
            if (request.data.statusCode === 200) {
              addSuccessToast("Booking successfully cancelled!");
              handleUpdate();
            } else {
              addErrorToast(request.data.message);
            }
          }
        }}
      />

      <WarningDialog
        open={openPatmentProfileWarningDialog}
        text={t("bookings.enabledYourPaymentSettings")}
        onClose={() => setOpenPatmentProfileWarningDialog(false)}
        onSubmit={async () => {

          navigate("/payment/profile", { replace: true })
        }}
      />
      <BookingLinkModal
        title={t("myEvents.paymentLinkGeneratedTitle", { eventName: bookingDetails?.className })}
        subtitle={t("bookings.paymentLinkGeneratedTitle")}
        open={bookingLinkModalOpen}
        handleClose={handleBookingLinkModalClose}
        bookingLink={shareLink}
      />
    </div>
  );
}
